import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { Providers } from "@/app/providers";
import { router } from "@/app/router";
import "@/styles/globals.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("No se encontró el elemento #root");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </React.StrictMode>,
);

/**
 * Dismiss del splash pre-React. En vez de un corte seco cuando React
 * monta su primer paint, le damos un fade-out de 240 ms (CSS
 * `[data-leaving]`) y luego lo removemos del DOM.
 *
 * Doble safety:
 *   - `requestAnimationFrame` doble espera a que React haya hecho el
 *     primer commit real (no solo la llamada a `render`).
 *   - Si el DOM lo removió otro proceso (hot reload), el optional
 *     chaining evita crash.
 */
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const splash = document.getElementById("arya-splash");
    if (!splash) return;
    splash.setAttribute("data-leaving", "true");
    window.setTimeout(() => splash.parentNode?.removeChild(splash), 260);
  });
});
